import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "primeicons/primeicons.css";
import logo from "../../Assets/Img/logo_new_green.png"
import icon from "../../Assets/Img/logo_icon.png";
import { getToken, setLogoutTime } from "../../Services/authService";
import "../../App.css";
import ToastElement from "../UiComponents/ToastElement";
import { saveStage, update } from "../../Services/opportunityService";
import { useOpportunity } from "../../Providers/OpportunityContext";
import ButtonElement from "../UiComponents/ButtonElement";
import { Dialog } from "primereact/dialog";
import _ from "lodash";
import socket from "../../socket";
import { getLogo } from "../../Services/customerServices";
import { useProgramme } from "../../Providers/ProgrammeContext";
import config from "../../Utils/Constants.json"
import { update as updateProgramme } from "../../Services/frameworkService";
import { useStakeholder } from "../../Providers/StakeholderContext";
import { update as updateStake } from "../../Services/clientService";
import { useBudget } from "../../Providers/BudgetContext";
import { saveUpdate } from "../../Services/planningService";
import { useBaseline } from "../../Providers/BaselineContext";
import { useBenchmarking } from "../../Providers/BenchmarkingContext";
import { saveUpdate as saveUpdateBench } from "../../Services/benchmarkingService";
import { saveUpdate as saveUpdateBaseline } from "../../Services/targetService";
import { UserContext } from "../../App";
import { InputIcon } from "primereact/inputicon";
import { get as getCusServ } from "../../Services/customerServices";
import { useLoginPermissionProvider } from "../../Providers/LoginPermissionProvider";
import { useSidebar } from "../../Providers/SidebarContext";
import { PanelMenu } from "primereact/panelmenu";
import { useIsEdited } from "../../Providers/IsEditedProvider";
import { isTokenExpired } from "../../Utils/Utils";

const SideBar = forwardRef((props, ref) => {
  const [isMobile, setIsMobile] = useState(false);
  const [customer, setCustomer] = useState({});
  const [showSidebar, setShowSidebar] = useState(false);
  const [open, setopen] = useState(true);
  const [newItems, setNewItems] = useState([]);
  const [fileName, setFileName] = useState('');
  const [items, setItems] = useState([]);
  const [customerShort, setCustomerShort] = useState('');
  const [customerDetails, setCustomerDetails] = useState({});
  const [activeTab, setActiveTab] = useState('');
  const [confirm, setConfirm] = useState(false)
  const [confirmProgramme, setConfirmProgramme] = useState(false)
  const [confirmStakeholder, setConfirmStakeholder] = useState(false)
  const [confirmBudget, setConfirmBudget] = useState(false)
  const [confirmBaseline, setConfirmBaseline] = useState(false)
  const [confirmBenchmarking, setConfirmBenchmarking] = useState(false)
  const [url, setUrl] = useState("");


  const { newLogo, newLogoData } = useContext(UserContext);
  const { globalLoginPermission } = useLoginPermissionProvider();
  const { setGlobalSidebarData } = useSidebar();
  const { globalOpportunityData, setGlobalOpportunityData } = useOpportunity();
  const { globalProgrammeData, setGlobalProgrammeData } = useProgramme();
  const { globalStakeholderData, setGlobalStakeholderData } = useStakeholder();
  const { globalBudgetData, setGlobalBudgetData } = useBudget();
  const { globalBaselineData, setGlobalBaselineData } = useBaseline();
  const { globalBenchmarkingData, setGlobalBenchmarkingData } = useBenchmarking();
  const { isEdited, setIsEdited } = useIsEdited();
  let navigate = useNavigate();

  const globalOpportunityDataRef = useRef(null);
  const globalProgrammeDataRef = useRef(null);
  const globalStakeholderDataRef = useRef(null);
  const globalBudgetDataRef = useRef(null);
  const globalBenchmarkingDataRef = useRef(null);
  const globalBaselineDataRef = useRef(null);

  var enduser = localStorage.getItem("enduser")
	if (enduser) {
		var tmpData = JSON.parse(enduser);
		if (tmpData === null) {
      navigate("/login")
      localStorage.clear()
    }
	}
	
	var userPrivileges = localStorage.getItem("user_privileges")
	if (userPrivileges) {
		var tmpPrivilege = JSON.parse(userPrivileges);
    if (tmpPrivilege !== undefined && tmpPrivilege !== null) {
      var frameworkPrivilege = tmpPrivilege[0].framework_readwrite;
      var planningPrevillege = tmpPrivilege[0].planning;
      var benchmarkingPrevillege = tmpPrivilege[0].benchmarking;
    } else {
      navigate("/login")
      localStorage.clear()
    }
	}

  let location = useLocation();
  const toastRef = useRef();

  useImperativeHandle(ref, () => ({
    childFunction(url) {
      handleConfirmation(url)
      // Any logic you want to execute when the function is called
    },
  }));

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1190);
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Call handler right away so state gets updated with initial window size

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    // Fetching end user data from local storage
    const enduserStr = localStorage.getItem("enduser");
    // Checking if end user data exists in local storage
    if (enduserStr) {
      // Parsing end user data
      const enduser = JSON.parse(enduserStr);
      // Setting customer ID state
      setCustomer(enduser);
    } else {
      navigate("/login")
      localStorage.clear()
    }
  }, []);

  useEffect(() => {
    getCustomerDetails();
  }, []);

  const getCustomerDetails = async () => {
    if (tmpData) {
      var customerData = await getCusServ(tmpData.customer)
      if (customerData && customerData.data) {
        setCustomerShort(customerData.data.customer_short)
        setCustomerDetails(customerData.data)
      }
    }
  }

  useEffect(() => {
    const currentPath = location.pathname;
    setIsEdited(false)

    if (props?.displayName && props?.displayName.length > 0) {
      if (currentPath.startsWith('/dashboard')) {
        setActiveTab(props?.displayName[0].display_name);
      } else if (currentPath.startsWith('/portfolio')) {
        setActiveTab(props?.displayName[1].display_name);
      } else if ((currentPath.startsWith('/stakeholders')) || (currentPath.startsWith('/stakeholder'))) {
        setActiveTab(props?.displayName[2].display_name);
      } else if ((currentPath.startsWith('/programmes')) || (currentPath.startsWith('/programme'))) {
        setActiveTab(props?.displayName[3].display_name);
      } else if (currentPath.startsWith('/addressbook')) {
        setActiveTab(props?.displayName[4].display_name);
      } else if (currentPath.startsWith('/businessPlan')) {
        setActiveTab(props?.displayName[5].display_name);
      } else if (currentPath.startsWith('/targetPlan')) {
        setActiveTab(props?.displayName[6].display_name);
      } else if (currentPath.startsWith('/benchmarking')) {
        setActiveTab(props?.displayName[8].display_name);
      } else if (currentPath.startsWith('/myAccount')) {
        setActiveTab(props?.displayName[7].display_name);
      } else if (currentPath.startsWith('/controlPanel')) {
        setActiveTab("Control Panel");
      }
    }
  }, [location.pathname, props?.displayName, items]);

  useEffect(() => {
    if (props?.displayName.length > 0 && customerShort) {
      const allItems = [
        {
          label:
            <a href={`/dashboard/${customerShort}`} target="_blank" rel="noopener noreferrer" className="sidebar-link">
              {props?.displayName[0].display_name}
            </a>,
          icon: "pi pi-home",
          command: () => {
            handleConfirmation(`/dashboard/${customerShort}`)
            setActiveTab(props?.displayName[0].display_name);
          },
          status: props?.displayName[0].status,
        },
        {
          label:
            <a href="/portfolio" target="_blank" rel="noopener noreferrer" className="sidebar-link">
              {props?.displayName[1].display_name}
            </a>,
          icon: "pi pi-briefcase",
          command: () => {
            handleConfirmation("/portfolio")
            setActiveTab(props?.displayName[1].display_name);
          },
          status: props?.displayName[1].status,
        },
        {
          label:
            <a href="/stakeholders" target="_blank" rel="noopener noreferrer" className="sidebar-link">
              {props?.displayName[2].display_name}
            </a>,
          icon: "pi pi-desktop",
          command: () => {
            handleConfirmation("/stakeholders")
            setActiveTab(props?.displayName[2].display_name);
          },
          status: props?.displayName[2].status,
          path: 'stakeholders'
        },
        {
          label:
            <a href="/programmes" target="_blank" rel="noopener noreferrer" className="sidebar-link">
              {props?.displayName[3].display_name}
            </a>,
          icon: "pi pi-file-o",
          command: () => {
            handleConfirmation("/programmes")
            setActiveTab(props?.displayName[3].display_name);
          },
          status: props?.displayName[3].status,
        },
        {
          label:
            <a href="/addressbook" target="_blank" rel="noopener noreferrer" className="sidebar-link">
              {props?.displayName[4].display_name}
            </a>,
          icon: "pi pi-address-book",
          command: () => {
            handleConfirmation("/addressbook")
            setActiveTab(props?.displayName[4].display_name);
          },
          status: props?.displayName[4].status,
        },
        {
          label:
            <a href={`/businessPlan/${customerShort}`} target="_blank" rel="noopener noreferrer" className="sidebar-link">
              {props?.displayName[5].display_name}
            </a>,
          icon: "pi pi-file-edit",
          command: () => {
            handleConfirmation(`/businessPlan/${customerShort}`)
            setActiveTab(props?.displayName[5].display_name);
          },
          status: props?.displayName[5].status,
        },
        {
          label:
            <a href={`/targetPlan/${customerShort}`} target="_blank" rel="noopener noreferrer" className="sidebar-link">
              {props?.displayName[6].display_name}
            </a>,
          icon: "pi pi-bullseye",
          command: () => {
            handleConfirmation(`/targetPlan/${customerShort}`)
            setActiveTab(props?.displayName[6].display_name);
          },
          status: props?.displayName[6].status,
        },
        {
          label:
            <a href={`/myAccount`} target="_blank" rel="noopener noreferrer" className="sidebar-link">
              {props?.displayName[7].display_name}
            </a>,
          icon: "pi pi-user",
          status: props?.displayName[7].status,
          command: () => { handleConfirmation("/myAccount"); setActiveTab(props?.displayName[7].display_name); },
        },
        {
          label:
            <a href={`/benchmarking/${customerShort}`} target="_blank" rel="noopener noreferrer" className="sidebar-link">
              {props?.displayName[8].display_name}
            </a>,
          icon: "pi pi-chart-pie",
          status: props?.displayName[8].status,
          command: () => { handleConfirmation(`/benchmarking/${customerShort}`); setActiveTab(props?.displayName[8].display_name); },
        },
        {
          label: "Control Panel",
          icon: "pi pi-cog",
          items: props.submenus,
          status: true,
        },
      ];
      const filteredItems = allItems.filter(item => {
        if (globalLoginPermission?.isRestricted) {
          return (item.icon === "pi pi-briefcase" || item.icon === "pi pi-desktop" || item.icon === "pi pi-user") && item;
        }
        return ((globalLoginPermission?.isAdmin || globalLoginPermission?.isBranchAdmin) || item.icon !== "pi pi-cog") && item.status;
        
      });
      setItems(filteredItems);
    }

  }, [props]);

  useEffect(() => {
    if (customer.customer != undefined || newLogo) {
      getLogoImage()
    }
  }, [customer, newLogo])

  useEffect(() => {
    if (!open) {
      if (items.length > 0) {
        var newItems = [];
        items.forEach((item) => {
          var icons = {
            icon: item.icon,
            command: item.command,
          };
          newItems.push(icons);
          setNewItems(newItems);
        });
      }
    }
  }, [open]);

  const menuCloseClick = () => {
    setShowSidebar(false);
    props.onSelectHamburger(showSidebar);
  };

  useEffect(() => {
      globalStakeholderDataRef.current = globalStakeholderData; 
      globalProgrammeDataRef.current = globalProgrammeData;
      globalOpportunityDataRef.current = globalOpportunityData;
      globalBudgetDataRef.current = globalBudgetData;
      globalBenchmarkingDataRef.current = globalBenchmarkingData;
      globalBaselineDataRef.current  = globalBaselineData;
    }, [globalStakeholderData, 
        globalProgrammeData, 
        globalOpportunityData, 
        globalBudgetData, 
        globalBenchmarkingData,
        globalBaselineData
  ]);

  const isEditedRef = useRef(isEdited);

  useEffect(() => {
    isEditedRef.current = isEdited;
  }, [isEdited])

  const handleConfirmation = async (url) => {
    if (isEditedRef.current){
      if (globalOpportunityDataRef.current) {
        setUrl(url)
        setConfirm(true)
      } else if (globalProgrammeDataRef.current) {
        setUrl(url)
        setConfirmProgramme(true)
      } else if (globalStakeholderDataRef.current) {
        setUrl(url)
        setConfirmStakeholder(true)
      } else if (globalBudgetDataRef.current) {
        if (!planningPrevillege) {
          navigate(url)
        } else {
          setUrl(url)
          setConfirmBudget(true)
        }
      } else if (globalBaselineDataRef.current) {
        setUrl(url)
        setConfirmBaseline(true)
      } else if (globalBenchmarkingDataRef.current) {
        if (!benchmarkingPrevillege) {
          navigate(url)
        } else {
          setUrl(url)
          setConfirmBaseline(true)
        }
      }else{
        setIsEdited(false);
        setGlobalBaselineData(null)
        setGlobalBenchmarkingData(null)
        setGlobalBudgetData(null)
        setGlobalOpportunityData(null)
        setGlobalStakeholderData(null)
        setGlobalProgrammeData(null)
        navigate(url)
      }
    }
    else {
      setIsEdited(false);
      setGlobalBaselineData(null)
      setGlobalBenchmarkingData(null)
      setGlobalBudgetData(null)
      setGlobalOpportunityData(null)
      setGlobalStakeholderData(null)
      setGlobalProgrammeData(null)
      navigate(url)
    }
  };

  const getLogoImage = async () => {
    var data = await getLogo(customer.customer)
    if (data && data.data) {
      if (data.data.fileName == data.data.fileLocation?.name) {
        var fileName = ((data.data.fileLocation) ? data.data.fileLocation.location : logo) + `?timestamp=${new Date().getTime()}`
        setFileName(fileName)
      } else {
        setFileName(logo)
      }
    }
    newLogoData(false)
  }

  const signOut = async () => {
    if (customer?.username) {
      try {
        const response = await setLogoutTime(customer?.username);
        if (response && response.data && response.data.success) {
          socket.emit('logout', { customer_id: customer._id });
          setGlobalBaselineData(null)
          setGlobalBenchmarkingData(null)
          setGlobalBudgetData(null)
          setGlobalOpportunityData(null)
          setGlobalStakeholderData(null)
          setGlobalProgrammeData(null)
          navigate("/login");
          localStorage.clear();
        } else {
          toastRef.current.showToast({
            type: "error",
            message: "Error",
          });
        }
      } catch (e) {
        console.error(e);
      }
    }
  };

  const toggleOpen = () => {
    setopen(!open);
    setGlobalSidebarData(!open)
    props.onSelectOpen(!open);
  };

  const saveopportunity = async () => {
    if (
      globalOpportunityData.bid_team?.status_update_logsdate !== "status update"
    ) {
      const saveStageResponse = await saveStage(
        globalOpportunityData._id,
        globalOpportunityData
      );
      const updateResponse = await update(
        globalOpportunityData._id,
        globalOpportunityData
      );

      if (saveStageResponse && saveStageResponse.data && saveStageResponse.data.success) {
        toastRef.current.showToast({
          type: "success",
          message: saveStageResponse.data.message,
        });
      }
      if (updateResponse && updateResponse.data && updateResponse.data.success) {
        toastRef.current.showToast({
          type: "success",
          message: updateResponse.data.message,
        });
      }
      if (saveStageResponse && saveStageResponse.data && saveStageResponse.data.success && updateResponse && updateResponse.data && updateResponse.data.success) {
        navigate(url)
        setGlobalOpportunityData(null)
        setConfirm(false)
      } else {
        setConfirm(false)
      }
    } else {
      const saveStageResponse = await saveStage(
        globalOpportunityData._id,
        globalOpportunityData
      );
      const updateResponse = await update(
        globalOpportunityData._id,
        globalOpportunityData
      );
      if (saveStageResponse && saveStageResponse.data && saveStageResponse.data.success) {
        toastRef.current.showToast({
          type: "success",
          message: saveStageResponse.data.message,
        });
      }
      if (updateResponse && updateResponse.data && updateResponse.data.success) {
        toastRef.current.showToast({
          type: "success",
          message: updateResponse.data.message,
        });
      }
      if (saveStageResponse && saveStageResponse.data && saveStageResponse.data.success && updateResponse && updateResponse.data && updateResponse.data.success) {
        navigate(url)
        setGlobalOpportunityData(null)
        setConfirm(false)
      } else {
        setConfirm(false)
      }
    }
  };

  const renderFooter = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">

          <>
            <ButtonElement label="No" className="cancel-new-button" onClick={() => { navigate(url); setConfirm(false); setGlobalOpportunityData(null) }} />
            <ButtonElement type="submit" label="Yes" className="save-button" onClick={saveopportunity} />
          </>

        </div>
      </div>
    );
  };

  const validateDate = (startDate, endDate) => {
    var startDateSplited = startDate.split('-');
    var endDateSplited = endDate.split('-');
    var startDate = new Date(startDateSplited[1] + '/' + startDateSplited[0] + '/' + startDateSplited[2]);
    var endDate = new Date(endDateSplited[1] + '/' + endDateSplited[0] + '/' + endDateSplited[2]);
    if (startDate < endDate) {
      return true;
    }
    return false;
  }

  const saveProgramme = async () => {
    if (!_.isUndefined(globalProgrammeData.summary)) {
      let isValidDate
      if (!_.isUndefined(globalProgrammeData.summary.framework_start_date) && !_.isUndefined(globalProgrammeData.summary.framework_end_date)) {
        isValidDate = validateDate(globalProgrammeData.summary.framework_start_date.text, globalProgrammeData.summary.framework_end_date.text);
      }
      if (isValidDate) {
        if (frameworkPrivilege == config[0].readOnly) {
          toastRef.current.showToast({
            type: "error",
            message: "Permission Denied"
          });
        } else if (frameworkPrivilege == config[1].readWrite && tmpData) {
          var updateData = await updateProgramme(globalProgrammeData._id, tmpData.customer, globalProgrammeData)
          if (updateData && updateData.data) {
            toastRef.current.showToast({
              type: "success",
              message: updateData.data.message
            });
            navigate(url)
            setGlobalProgrammeData(null)
            setConfirmProgramme(false)
          } else {
            toastRef.current.showToast({
              type: "error",
              message: updateData.data.message
            });
            setConfirmProgramme(false)
          }
        }
      } else {
        toastRef.current.showToast({
          type: "error",
          message: "Enter Valid Start Date & End Date"
        });
        setConfirmProgramme(false)
      }
    }
  }

  const renderFooterProgramme = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">

          <>
            <ButtonElement label="No" className="cancel-new-button" onClick={() => { navigate(url); setConfirmProgramme(false); setGlobalProgrammeData(null) }} />
            <ButtonElement type="submit" label="Yes" className="save-button" onClick={saveProgramme} />
          </>

        </div>
      </div>
    );
  };

  const saveStakeholder = async () => {
    if (globalStakeholderData) {
      try {
        const res = await updateStake(globalStakeholderData._id, globalStakeholderData);
        if (res && res.data && res.data.success === true) {
          toastRef.current.showToast({
            type: 'success',
            message: `${res.data.message}`
          });
          navigate(url)
          setGlobalStakeholderData(null)
          setConfirmStakeholder(false)
        }
        else {
          toastRef.current.showToast({
            type: 'error',
            message: `${res.data.message}`
          });
          setConfirmStakeholder(false)
        }
      } catch (error) {
        console.error(error);
        setConfirmStakeholder(false)
      }
    }
  }

  const renderFooterStakeholder = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">

          <>
            <ButtonElement label="No" className="cancel-new-button" onClick={() => { navigate(url); setConfirmStakeholder(false); setGlobalStakeholderData(null) }} />
            <ButtonElement type="submit" label="Yes" className="save-button" onClick={saveStakeholder} />
          </>

        </div>
      </div>
    );
  };

  const saveBudget = async () => {
    var inavalidRecords = [];
    var validRecords = [];
    globalBudgetData.sales_revenue.filter(function (row) {
      if (row.business_unit == undefined && row.sector == undefined && row.service == undefined) {
        inavalidRecords.push(row);
      }
    });
    globalBudgetData.sales_revenue.filter(function (row) {
      if (row.business_unit != undefined || row.sector != undefined || row.service != undefined) {
        validRecords.push(row);
      }
    });

    inavalidRecords.filter(function (record) {
      _.remove(globalBudgetData.sales_revenue, record);
    });
    if (tmpData) {
      var planSave = await saveUpdate(tmpData.customer, globalBudgetData)
      if (planSave && planSave.data) {
        toastRef.current.showToast({
          type: 'success',
          message: "Planning Info Updated Successfully"
        });
        navigate(url)
        setGlobalBudgetData(null)
        setConfirmBudget(false)
      }
    }
  }

  const renderFooterBudget = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">

          <>
            <ButtonElement label="No" className="cancel-new-button" onClick={() => { navigate(url); setConfirmBudget(false); setGlobalBudgetData(null) }} />
            <ButtonElement type="submit" label="Yes" className="save-button" onClick={saveBudget} />
          </>

        </div>
      </div>
    );
  };

  const saveBaseline = async () => {
    var inavalidRecords = [];
    var validRecords = [];
    if (globalBaselineData) {

      globalBaselineData.impact_target.filter(function (row) {
        if (row.logFrameGoal == undefined && row.logFrameTarget == undefined && row.logFrameIndicator == undefined && row.logFrameSubIndicator == undefined) {
          inavalidRecords.push(row);
        }
      });
      globalBaselineData.impact_target.filter(function (row) {
        if (row.logFrameGoal == undefined && row.logFrameTarget == undefined && row.logFrameIndicator == undefined && row.logFrameSubIndicator == undefined) {
          validRecords.push(row);
        }
      });
      inavalidRecords.filter(function (record) {
        _.remove(globalBaselineData.impact_target, record);
      });
      if (tmpData) {
        var targetSave = await saveUpdateBaseline(tmpData.customer, globalBaselineData)
        if (targetSave && targetSave.data) {
          if (targetSave.data.success) {
            toastRef.current.showToast({
              type: 'success',
              message: "Target Info Updated Successfully"
            });
            navigate(url)
            setGlobalBaselineData(null)
            setConfirmBaseline(false)
          } else {
            toastRef.current.showToast({
              type: 'error',
              message: "Selected year not available"
            });
            navigate(url)
            setGlobalBaselineData(null)
            setConfirmBaseline(false)
          }
        }
      }
    }
  }

  const renderFooterBaseline = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">

          <>
            <ButtonElement label="No" className="cancel-new-button" onClick={() => { navigate(url); setConfirmBaseline(false); setGlobalBaselineData(null) }} />
            <ButtonElement type="submit" label="Yes" className="save-button" onClick={saveBaseline} />
          </>

        </div>
      </div>
    );
  };

  const saveBenchmarking = async () => {
    var inavalidRecords = [];
    var validRecords = [];
    globalBenchmarkingData.budget.filter(function (row) {
      if (row.business_unit == undefined && row.sector == undefined && row.service == undefined && row.questions == undefined) {
        inavalidRecords.push(row);
      }
    });
    globalBenchmarkingData.budget.filter(function (row) {
      if (row.business_unit != undefined || row.sector != undefined || row.service != undefined || row.questions != undefined) {
        validRecords.push(row);
      }
    });

    inavalidRecords.filter(function (record) {
      _.remove(globalBenchmarkingData.budget, record);
    });
    if (tmpData) {
      var benchSave = await saveUpdateBench(tmpData.customer, globalBenchmarkingData)
      if (benchSave && benchSave.data) {
        toastRef.current.showToast({
          type: 'success',
          message: "Benchmarking Info Updated Successfully"
        });
        navigate(url)
        setGlobalBenchmarkingData(null)
        setConfirmBenchmarking(false)
      }
    }
  }

  const renderFooterBenchmarking = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">

          <>
            <ButtonElement label="No" className="cancel-new-button" onClick={() => { navigate(url); setConfirmBenchmarking(false); setGlobalBenchmarkingData(null) }} />
            <ButtonElement type="submit" label="Yes" className="save-button" onClick={saveBenchmarking} />
          </>

        </div>
      </div>
    );
  };

  return (
    <div
      className={
        open
          ? `sidebar ${props.isOpen ? "show" : "hide"}`
          : " sidebar sidebarClosed"
      }
    >
      <Dialog visible={confirm} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm Save" className="table-dialog width-32" onHide={() => { navigate(url); setConfirm(false); setGlobalOpportunityData(null); setIsEdited(false) }} footer={renderFooter()} draggable={false}>
        <div className="confirmation-content">
          <span>
            <span className="table-description">
              You have made change(s). Do you want to save it?
            </span>
          </span>
        </div>
      </Dialog>
      <Dialog visible={confirmProgramme} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm Save" className="table-dialog width-32" onHide={() => { navigate(url); setConfirmProgramme(false); setGlobalProgrammeData(null); setIsEdited(false) }} footer={renderFooterProgramme()} draggable={false}>
        <div className="confirmation-content">
          <span>
            <span className="table-description">
              You have made change(s). Do you want to save it?
            </span>
          </span>
        </div>
      </Dialog>
      <Dialog visible={confirmStakeholder} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm Save" className="table-dialog width-32" onHide={() => { navigate(url); setConfirmStakeholder(false); setGlobalStakeholderData(null); setIsEdited(false) }} footer={renderFooterStakeholder()} draggable={false}>
        <div className="confirmation-content">
          <span>
            <span className="table-description">
              You have made change(s). Do you want to save it?
            </span>
          </span>
        </div>
      </Dialog>
      <Dialog visible={confirmBudget} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm Save" className="table-dialog width-32" onHide={() => { navigate(url); setConfirmBudget(false); setGlobalBudgetData(null); setIsEdited(false) }} footer={renderFooterBudget()} draggable={false}>
        <div className="confirmation-content">
          <span>
            <span className="table-description">
              You have made change(s). Do you want to save it?
            </span>
          </span>
        </div>
      </Dialog>
      <Dialog visible={confirmBaseline} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm Save" className="table-dialog width-32" onHide={() => { navigate(url); setConfirmBaseline(false); setGlobalBaselineData(null); setIsEdited(false) }} footer={renderFooterBaseline()} draggable={false}>
        <div className="confirmation-content">
          <span>
            <span className="table-description">
              You have made change(s). Do you want to save it?
            </span>
          </span>
        </div>
      </Dialog>
      <Dialog visible={confirmBenchmarking} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm Save" className="table-dialog width-32" onHide={() => { navigate(url); setConfirmBenchmarking(false); setGlobalBenchmarkingData(null); setIsEdited(false) }} footer={renderFooterBenchmarking()} draggable={false}>
        <div className="confirmation-content">
          <span>
            <span className="table-description">
              You have made change(s). Do you want to save it?
            </span>
          </span>
        </div>
      </Dialog>
      <ToastElement ref={toastRef} />
      <div className={open ? "sidenav" : "sidenavClosed"}>
        <div>
          <div className={open ? "mt-13 d-flex height-50" : "mt-13 d-flex logo-w-h"}>
            <img
              src={open ? fileName : icon}
              className={open ? "logo" : "logo-icon"}
            />
            {
              open &&
              <InputIcon
                className="pi pi-angle-double-left pointer angle-sidebar"
                onClick={toggleOpen}
              />
            }
            {
              !open &&
              <InputIcon
                className="pi pi-angle-double-right pointer angle-right-sidebar"
                onClick={toggleOpen}
              />
            }
          </div>
          <div className={open ? "sidebarMenu mt-10" : "sidebarMenuClosed mt-10"}>
            {
              open ?
                items.map((item, index) => {
                  const isActive =
                    (item.label === "Control Panel" && location.pathname.startsWith("/controlPanel")) ||
                    activeTab === item.label?.props?.children;
                  return (
                    <div key={index} className={isActive ? 'active-menu-item' : ''}>
                      <PanelMenu model={[{ ...item }]} />
                    </div>
                  )
                }) :
                newItems.map((item, index) => {
                  const isActive =
                    (item.label === "Control Panel" && location.pathname.startsWith("/controlPanel")) ||
                    activeTab === item.label?.props?.children;
                  return (
                    <div key={index} className={isActive ? 'active-menu-item' : ''}>
                      <PanelMenu model={[{ ...item }]} />
                    </div>
                  )
                })
            }
            <div className={`close-sidebar ${props.isOpen ? "show" : "hide"}`}>
              <i className="pi pi-times navIcon" onClick={menuCloseClick}></i>
            </div>
          </div>
        </div>
        <div className="ml-14 mb-3" >
          <div className="p-grid sidebar-footer">
            {
              <div className="p-col-12 d-flex justify-between align-center mar-t-5 ">
                {open ? (
                  <div className="p-col-8">
                    <p className="font-normal fs-14 mar-b-4 font-white">
                      {customer.firstname + " " + customer.surname}
                    </p>
                  </div>
                ) : (
                  ""
                )}
                <div className="p-col-2 align-center">
                  <i
                    className="pi pi-sign-out sm-add-button"
                    onClick={signOut}
                  ></i>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  );
})
export default SideBar;